export const getUserMedia = async (
  constraints: MediaStreamConstraints = {
    video: true,
    audio: true,
  },
): Promise<MediaStream | null> => {
  try {
    const mediaStream = await navigator.mediaDevices.getUserMedia(constraints);
    return mediaStream;
  } catch (err) {
    console.error('Error accessing webcam:', err);
    return null;
  }
};
